/* tslint:disable */
/* eslint-disable */
/**
 * Melco Rest Services
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    MelcoModelsCustomWarning,
    MelcoModelsCustomWarningFromJSON,
    MelcoModelsCustomWarningFromJSONTyped,
    MelcoModelsCustomWarningToJSON,
    MelcoModelsUserProductListItem,
    MelcoModelsUserProductListItemFromJSON,
    MelcoModelsUserProductListItemFromJSONTyped,
    MelcoModelsUserProductListItemToJSON,
} from './';

/**
 * 
 * @export
 * @interface MelcoModelsGenericList1MelcoModelsUserProductListItem
 */
export interface MelcoModelsGenericList1MelcoModelsUserProductListItem {
    /**
     * 
     * @type {Array<MelcoModelsUserProductListItem>}
     * @memberof MelcoModelsGenericList1MelcoModelsUserProductListItem
     */
    list: Array<MelcoModelsUserProductListItem>;
    /**
     * 
     * @type {Array<MelcoModelsCustomWarning>}
     * @memberof MelcoModelsGenericList1MelcoModelsUserProductListItem
     */
    warning_list?: Array<MelcoModelsCustomWarning> | null;
    /**
     * 
     * @type {number}
     * @memberof MelcoModelsGenericList1MelcoModelsUserProductListItem
     */
    total: number;
}

export function MelcoModelsGenericList1MelcoModelsUserProductListItemFromJSON(json: any): MelcoModelsGenericList1MelcoModelsUserProductListItem {
    return MelcoModelsGenericList1MelcoModelsUserProductListItemFromJSONTyped(json, false);
}

export function MelcoModelsGenericList1MelcoModelsUserProductListItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): MelcoModelsGenericList1MelcoModelsUserProductListItem {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'list': ((json['list'] as Array<any>).map(MelcoModelsUserProductListItemFromJSON)),
        'warning_list': !exists(json, 'warning_list') ? undefined : (json['warning_list'] === null ? null : (json['warning_list'] as Array<any>).map(MelcoModelsCustomWarningFromJSON)),
        'total': json['total'],
    };
}

export function MelcoModelsGenericList1MelcoModelsUserProductListItemToJSON(value?: MelcoModelsGenericList1MelcoModelsUserProductListItem | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'list': ((value.list as Array<any>).map(MelcoModelsUserProductListItemToJSON)),
        'warning_list': value.warning_list === undefined ? undefined : (value.warning_list === null ? null : (value.warning_list as Array<any>).map(MelcoModelsCustomWarningToJSON)),
        'total': value.total,
    };
}


